import React, { Component } from 'react';

const DESCRIPTIONS="Enter your email address below and we will send you further instruction on how to reset your password."
class ForgotPassword extends Component {
  render() {
    return (
      <div> reset password
          

           </div>
    );
  }
}

export default ForgotPassword;
